var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRighticonblue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 30,
    height: 30,
    transform: "translate(85.894 253.472)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-85.894 -253.472)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle-fill",
    transform: "translate(85.894 253.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15ZM22.556,9.319a1.406,1.406,0,0,0-2.025.041l-6.512,8.3L10.1,13.731a1.406,1.406,0,0,0-1.987,1.987l4.961,4.963a1.406,1.406,0,0,0,2.023-.038l7.485-9.356a1.406,1.406,0,0,0-.019-1.969Z",
    fill: "#1F65DB"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRighticonblue);
export default __webpack_public_path__ + "static/media/righticonblue.e2e4d87c499bfd426b408c6457f89460.svg";
export { ForwardRef as ReactComponent };